import { jsxs as l, jsx as i } from "react/jsx-runtime";
function d(r) {
  return /* @__PURE__ */ l(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...r,
      children: [
        /* @__PURE__ */ l("g", { "clip-path": "url(#clip0_324073_7693)", children: [
          /* @__PURE__ */ i(
            "path",
            {
              d: "M9.9998 20C15.5229 20 20 15.5225 20 9.9998C20 4.47708 15.5229 0 9.9998 0C4.47668 0 0 4.47708 0 9.9998C0 15.5225 4.47708 20 9.9998 20Z",
              fill: "#2196F3"
            }
          ),
          /* @__PURE__ */ i(
            "path",
            {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M5.86768 12.858H12.4814V8.0083C12.4814 7.27765 11.8893 6.68555 11.1587 6.68555H4.54492V11.5353C4.54492 12.2659 5.13702 12.858 5.86768 12.858ZM13.3629 11.0947L16.0084 12.858V6.68555L13.3633 8.44922L13.3629 11.0947Z",
              fill: "rgb(var(--background-secondary))"
            }
          )
        ] }),
        /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "clip0_324073_7693", children: /* @__PURE__ */ i("rect", { width: "20", height: "20", fill: "rgb(var(--background-secondary))" }) }) })
      ]
    }
  );
}
export {
  d as ZoomLocationIcon
};
